export default "__VITE_ASSET__DZLaTYHo__"